import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const fb = require('./store/firebaseConfig.js')

Vue.config.productionTip = false;

let app
fb.auth.onAuthStateChanged(user => {
  // console.log('RELOAD', user)
  if (user) {
    store.commit('setCurrentUser', user)
    store.commit('setFetching', true)
    store.dispatch('fetchUserProfile')
    store.dispatch('fetchUserWaivers')
    store.dispatch('fetchUserSurveys')
    store.commit('setFetching', false)
  }
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }
})
